"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequireAuth = void 0;
const react_1 = require("react");
const useAuth_1 = require("../hooks/useAuth");
const react_router_dom_1 = require("react-router-dom");
const RequireAuth = ({ children, signinRoute }) => {
    const auth = (0, useAuth_1.useAuth)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        if (!auth.userAccount) {
            if (typeof window !== undefined) {
                navigate(signinRoute || '/signin');
            }
        }
    }, [auth.userAccount]);
    //Note: components wrapped in RequireAuth will never render on the first request, this is to match the server side
    //where login will always be false
    return auth.userAccount ? children : null;
};
exports.RequireAuth = RequireAuth;
//# sourceMappingURL=RequireAuth.js.map